export default {
    SET_TEMPLATES(state, templates) {
        state.templates = templates.items
        state.totalPages = templates.total_pages
    },
    ADD_TEMPLATE(state, template) {
        state.templates.unshift(template)
    },
    UPDATE_TEMPLATE(state, template) {
        const templateIndex = state.templates.findIndex((u) => u.id === template.id)
        Object.assign(state.templates[templateIndex], template)
    },
    DELETE_TEMPLATE(state, templateId) {
        const ItemIndex = state.templates.findIndex((u) => u.id === templateId)
        state.templates.splice(ItemIndex, 1)
    },
    ADD_TEMPLATE_INFOS(state, template) {
        state.templateInfos = template
    }
}
